import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import {
  Card,
  Button,
  CardImg,
  CardTitle,
  CardText,
  CardGroup,
  CardSubtitle,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  TabContent,
  TabPane,
} from "reactstrap";

import FaCalendar from "react-icons/lib/fa/calendar";
import FaClockO from "react-icons/lib/fa/clock-o";
import FaMapMarker from "react-icons/lib/fa/map-marker";

import EventVenue from "./eventVenue";
import "regenerator-runtime/runtime";
import { isMobile } from "react-device-detect";
export default class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comingEvents: [],
      previousEvents: [],
      selectedTab: "coming",
    };
  }
  componentDidMount() {
    this.transformEvent();
  }

  getEvents = currencyCode => {
    console.log("get events");
    return axios
      .get(
        `https://www.eventbriteapi.com/v3/users/me/owned_events/?token=SZPKTX6HTE6HDIWIMFNP`
      )
      .then(response => {
        console.log(response.data.events);
        return response.data.events;
      });
  };

  // Some weird hack here to enable the proud build and dev build to work at the same time
  transformEvent = () =>
    (async () => {
      const currentTime = new Date();
      const events = await this.getEvents();
      const venues = [];

      const comingEvents = events.filter(
        event => new Date(event.start.local) > currentTime
      );
      const previousEvents = events
        .filter(event => new Date(event.start.local) < currentTime)
        .sort((a, b) => {
          return new Date(b.start.local) - new Date(a.start.local);
        });
      if (comingEvents.length > 0) {
        await this.setState({
          comingEvents,
          previousEvents,
          venues,
        });
      } else {
        await this.setState({
          comingEvents,
          previousEvents,
          venues,
          selectedTab: "past",
        });
      }
    })();

  renderCardGroups = () => {
    const { comingEvents, previousEvents, venues } = this.state;

    if (comingEvents.length < 1 || previousEvents.length < 1) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "80%",
            alignItems: "center",
            marginLeft: "1em",
          }}
        >
          <Card style={{ width: "100%" }}>
            <CardBody>
              <CardTitle style={{ fontSize: "25px" }}>
                It seems nothing is planned right now
              </CardTitle>
              <CardText style={{ marginTop: "1em" }}>
                Stay tuned for updates
              </CardText>
            </CardBody>
          </Card>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "80%",
          alignItems: "center",
          marginLeft: "1em",
        }}
      >
        {comingEvents.map(event => (
          <Card style={{ marginBottom: "1em" }}>
            {event.logo ? (
              <CardImg top width="100%" src={event.logo.url} />
            ) : (
              <div />
            )}
            <CardBody>
              <CardTitle style={{ fontSize: "25px" }}>
                {event.name.text}
              </CardTitle>
              <CardSubtitle>
                <FaCalendar style={{ color: "#f77f00", marginRight: "1em" }} />
                {moment(event.start.local).format("DD-MM-YYYY")}
                <FaClockO
                  style={{
                    color: "#f77f00",
                    marginLeft: "1em",
                    marginRight: "1em",
                  }}
                />
                {`${moment(event.start.local).format("HH:mm")} - ${moment(
                  event.end.local
                ).format("HH:mm")}`}
                <EventVenue venueId={event.venue_id} />
              </CardSubtitle>
              <CardText style={{ marginTop: "1em" }}>
                {event.description.text}
              </CardText>
            </CardBody>
            <div
              style={{
                width: "100%",
                height: "4em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f77f00",
              }}
            >
              <a href={event.url} style={{ color: "white" }}>
                Get Tickets
              </a>
            </div>
          </Card>
        ))}
      </div>
    );
  };

  renderPastCardGroups = () => {
    const { comingEvents, previousEvents, venues } = this.state;

    if (previousEvents.length < 1) {
      return <div />;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "80%",
          alignItems: "center",
          marginLeft: "1em",
        }}
      >
        {previousEvents.map(event => (
          <Card style={{ marginBottom: "1em" }}>
            {event.logo ? (
              <CardImg top width="100%" src={event.logo.url} />
            ) : (
              <div />
            )}
            <CardBody>
              <CardTitle style={{ fontSize: "25px" }}>
                {event.name.text}
              </CardTitle>
              <CardSubtitle>
                <FaCalendar style={{ color: "#f77f00", marginRight: "1em" }} />
                {moment(event.start.local).format("DD-MM-YYYY")}
                <FaClockO
                  style={{
                    color: "#f77f00",
                    marginLeft: "1em",
                    marginRight: "1em",
                  }}
                />
                {`${moment(event.start.local).format("HH:mm")} - ${moment(
                  event.end.local
                ).format("HH:mm")}`}
                <EventVenue venueId={event.venue_id} />
              </CardSubtitle>
              <CardText style={{ marginTop: "1em" }}>
                {event.description.text}
              </CardText>
            </CardBody>
          </Card>
        ))}
      </div>
    );
  };

  render() {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ListGroup style={isMobile ? { display: "none" } : {}}>
          <ListGroupItem
            tag="button"
            action
            onClick={() => {
              this.setState({ selectedTab: "coming" });
            }}
            style={
              this.state.selectedTab === "coming"
                ? { backgroundColor: "#f77f00", color: "white" }
                : {}
            }
          >
            Coming events
          </ListGroupItem>
          <ListGroupItem
            tag="button"
            action
            onClick={() => {
              this.setState({ selectedTab: "past" });
            }}
            style={
              this.state.selectedTab === "past"
                ? { backgroundColor: "#f77f00", color: "white" }
                : {}
            }
          >
            Past events
          </ListGroupItem>
        </ListGroup>
        {this.state.selectedTab === "coming"
          ? this.renderCardGroups()
          : this.renderPastCardGroups()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/events/events.js